import React, { Fragment, useState } from 'react';
import AutTable from '../../../blocks/aut-grid-table';

import { getNewCustomFVITableColumns } from '../../../../utils/data';
import { NewAnomalyItem as Anomaly, CoverDataItem } from '../../../../utils/models';

interface NewPipingAnomalyItemsProps {
	locationOptions: CoverDataItem[];
	FormComponent: any;
	nextAnomalyID: number;
	anomalyItems: Anomaly[];
	onDataChange: (items: Anomaly[]) => void;
}

const AnomalyTypes: React.FC<NewPipingAnomalyItemsProps> = (props) => {
	const [itemToEdit, setItemToEdit] = useState<Anomaly | null>(null);

	const getNewAnomalyID = () => {
		if (props.anomalyItems.length === 0) return props.nextAnomalyID;

		return props.anomalyItems[props.anomalyItems.length - 1].id + 1;
	};

	const handleAddItem = (item: Anomaly) => {
		const newAnomalyItems = [...props.anomalyItems, { ...item, id: getNewAnomalyID() }];
		props.onDataChange(newAnomalyItems);
	};

	const handleDeleteItem = (item: Anomaly): void => {
		const newAnomalyItems = props.anomalyItems.filter((i) => i.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (item: Anomaly): void => {
		props.onDataChange(props.anomalyItems.map((anomaly) => anomaly.id === itemToEdit!.id ? item : anomaly));
		setItemToEdit(null);
	};

	const handleCancelEdit = (): void => {
		setItemToEdit(null);
	};

	return (
		<Fragment>
			<props.FormComponent 
                onCancel={itemToEdit && handleCancelEdit}
                anomalyItem={itemToEdit}
				options={props.locationOptions}
                onSave={itemToEdit ? handleEditItem : handleAddItem} 
			/>

			<div className="divider my-4"></div>

			<AutTable
				data={props.anomalyItems}
				tableColumns={getNewCustomFVITableColumns()}
				onDeleteItem={handleDeleteItem}
				onEditItem={(item: Anomaly) => setItemToEdit(item)}
			/>
		</Fragment>
	);
};

export default AnomalyTypes;
